import { post, get, retryAjax } from '@/utils/http/http'
import { getToken } from '../../../utils'
import { PERM_GW_URL, TRIAL_URL } from '@/utils/http/baseUrl'

// 查询用户所拥有的权限
export const getUserAuth = data =>
  retryAjax({
    retryUrl: `${PERM_GW_URL}/v1/user_permission/list_user_permission`,
    requestFn: post,
    maxCount: 2,
  })(`${PERM_GW_URL}/v1/user_permission/list_user_permission`, data, false, {
    timeout: 5000,
    headers: {
      tenantid: window.zbvd.zbid,
      appcode: 'agent_setting',
      Authorization: `Bearer ${getToken()}`,
    },
  })
// 获取灰度直播间资格
export const getAgentGray = params =>
  get(`${TRIAL_URL}/v1/is_trial/perm_agent_setting`, params, false)
